export default __webpack_public_path__ + "static/media/card-project4.70561a4e.png";